import { z } from 'zod'

/**
 * Les messages de validation sont des clés i18n : les formulaires les résolvent
 * au rendu, ce qui laisse le schéma indépendant de la langue affichée.
 */
export const loginSchema = z.object({
  email: z.string().email('auth.errors.invalid_email'),
  password: z.string().min(1, 'auth.errors.password_required'),
})

export const registerSchema = z
  .object({
    email: z.string().email('auth.errors.invalid_email'),
    password: z
      .string()
      .min(8, 'auth.errors.password_min')
      .regex(/[A-Z]/, 'auth.errors.password_uppercase')
      .regex(/\d/, 'auth.errors.password_digit'),
    password_confirmation: z.string(),
    first_name: z.string().min(1, 'auth.errors.first_name_required').max(100),
    last_name: z.string().min(1, 'auth.errors.last_name_required').max(100),
    language: z.string().default('fr'),
  })
  .refine((d) => d.password === d.password_confirmation, {
    message: 'auth.errors.passwords_mismatch',
    path: ['password_confirmation'],
  })

export type LoginFormData = z.infer<typeof loginSchema>
export type RegisterFormData = z.infer<typeof registerSchema>

/** Valeurs telles que saisies : `language` a une valeur par défaut, donc optionnelle. */
export type RegisterFormInput = z.input<typeof registerSchema>
